import jquery from "jquery";
window.$ = window.jQuery = jquery;
import Flickity from 'flickity';

const selectors = {
  slider: '[data-section-type="image-with-slider"] .image-slider-wrapper__inner',
}

jQuery(function() {
  const $carousel = $(selectors.slider);
  if (!!$carousel.length) {
    var flkty = new Flickity( selectors.slider, {
      percentPosition: true,
      contain: false,
      wrapAround: false,
      groupCells: false,
      pageDots: false,
      imagesLoaded: true,
      adaptiveHeight: false,
      lazyLoad: true,
      resize: true,
      cellAlign: 'left',
      prevNextButtons: true,
      selectedAttraction: 0.2,
      friction: 0.8
    });
  }
 })